import React from "react";
import "../../../css/WhyChooseUs.css";
import { ReactComponent as FeesIcon } from "../../../assets/icons/AffordabilityIcon.svg";
import { ReactComponent as PastrolCareIcon } from "../../../assets/icons/PeaceIcon.svg";
import { ReactComponent as PlanningIcon } from "../../../assets/icons/TaxIcon.svg";
import { ReactComponent as StabilityIcon } from "../../../assets/icons/FutureIcon.svg";
import { ReactComponent as AffordabilityIcon } from "../../../assets/icons/AffordabilityIcon.svg";
import { ReactComponent as PartnershipIcon } from "../../../assets/icons/CapitalProtectionIcon.svg";
import { ReactComponent as ProviderIcon } from "../../../assets/icons/TrustedProviderIcon.svg";

const features = [
  {
    icon: <FeesIcon />,
    title: "All fees and additional costs covered",
    text: "Your pupil will not miss out on valuable activities and trips. A complete education is guaranteed",
  },
  {
    icon: <PastrolCareIcon />,
    title: "Pastoral Care",
    text: "A natural extension, at no cost and with no commercial involvement",
  },
  {
    icon: <PlanningIcon />,
    title: "Planning",
    text: "Fee income continuity, reduced risk of unexpected withdrawals — the practical benefit of a simple introduction",
  },
  {
    icon: <StabilityIcon />,
    title: "Stability",
    text: "Staff can support children knowing the child’s education is secure",
  },
  {
    icon: <PartnershipIcon/>,
    title: "A Deeper Partnership",
    text: "A successful education depends on more than what happens in the classroom. This introduction reflects a school that understands that.",
  },

  {
    icon: <ProviderIcon />,
    title: "Trusted Provider",
    text: "FCA approved, full compliance and regulatory reliability",
  },
];

const WhyPartnerWithUs = () => {
  return (
    <section className="plan section-bg section-bg--blue">
      <div className="why-choose-us__container">
        <h4>WHY PARTNER WITH US</h4>
        <div className="divider" />
        <div className="content">
          Our school partners trust us because we{" "}
          <span className="content-medium accent">
            safeguard what matters most: your pupils’ education.
          </span>
        </div>

        <div className="why-choose-us__grid">
          {features.map((item, index) => (
            <div className="why-choose-us__card big" key={index}>
              <div className="why-choose-us__icon">{item.icon}</div>
              <div className="body-medium">{item.title}</div>
              <div className="body">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPartnerWithUs;
